import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./componen/Home";
import Login from "./componen/Login";
import InformasiDasarHukum from "./componen/InformasiDasarHukum";
import Register from "./componen/Register";
import { DataRecapPages } from "./pages/DataRecapPages";
import { QuestionnaireFormPages } from "./pages/QuestionnaireFormPages";
import { UploadFotoPages } from "./pages/UploadFotoPages";
import { UploadPdfPages } from "./pages/UploadPdfPages";
import { MapsPages } from "./pages/MapsPages";
import ResetPassword from "./componen/ResetPassword";
import { DashboardPages } from "./pages/DashboardPages";
import { RegisterUsulanPages } from "./pages/RegisterUsulanPages";
import VerifikasiPages from "./pages/VerifikasiPages";
import { DataBacklogPages } from "./pages/DataBacklogPages";
import { UserListPages } from "./pages/UserListPages";
import QuestionnaireForm from "./componen/QuestionnaireForm";
import RekapVerifikasiPages from "./pages/RekapVerifikasiPages";
import RegisterDataUsulan from "./pages/RegisterDataUsulan";
import PrivateRoute from "./componen/PrivateRoute";
import { ROUTE_ACCESS } from "./config/roleConfig";
import { DataBantuanPages } from "./pages/Bantuan/DataBantuanPages";
import { DetailBantuanPages } from "./pages/Bantuan/DetailBantuanPages";
import { TambahDataBantuanPages } from "./pages/Bantuan/TambahDataBantuanPages";
import { ProsesBantuanPages, ProsesBantuanDetailPages } from "./pages/Bantuan/ProsesBantuanPages";
import { MonitoringBantuanPages } from "./pages/Bantuan/MonitoringBantuanPages";
import { PresentaseBantuanPages } from "./pages/Bantuan/PresentaseBantuanPages";
import { RekapBantuanPages } from "./pages/Bantuan/RekapBantuanPages";
import { KeluhanPages } from "./pages/Keluhan/KeluhanPages";
import { DataSupplierPages } from "./pages/Supplier/DataSupplierPages";
import { DataPembelianSupplierPages } from "./pages/Supplier/DataPembelianSupplierPages";
import { InputPembelianPages } from "./pages/Supplier/InputPembelianPages";
import { SupplierBuktiTransferPages } from "./pages/Supplier/SupplierBuktiTransferPages";
import { SupplierPengirimanPages } from "./pages/Supplier/SupplierPengirimanPages";
import { MonitoringPenagihanSupplierPages } from "./pages/Supplier/MonitoringPenagihanSupplierPages";
import { SupplierRabLaporanPages } from "./pages/Supplier/SupplierRabLaporanPages";
import { RekapTransaksiBantuanPages } from "./pages/Bantuan/RekapTransaksiBantuanPages"
import { DataSkPenetapanPages } from "./pages/Bantuan/DataSkPenetapanPages"
import DataUpahTukangPages from "./pages/upahTukang/DataUpahTukangPages";
import {
  AgrDashboardPages,
  TflDashboardPages,
  FasilitatorDashboardPages,
  SupplierDashboardPages,
  PpkDashboardPages,
  KabidDashboardPages,
  KadisDashboardPages,
  BupatiDashboardPages,
  KepalaDinasDashboardPages,
} from "./pages/role/RoleDashboardPages";
import KoordTflDashboardPages from "./pages/KoordTfl/KoordTflDashboardPages";
import KoordTflMonitoringPages from "./pages/KoordTfl/KoordTflMonitoringPages";
import { NotaPengirimanPages } from "./pages/notaPengiriman/NotaPengirimanPages";
import ExecutiveVerifikasiDetail from "./componen/kepaladinas/ExecutiveVerifikasiDetail";
import ExecutiveQuestionnaireDetail from "./componen/kepaladinas/ExecutiveQuestionnaireDetail";
import ExecutiveNotaDetail from "./componen/kepaladinas/ExecutiveNotaDetail";
import { RegisterAkunMasyarakat } from "./componen/RegisterAkunMasyarakat";
import { PenerimaDashboardPages } from "./pages/Penerima/PenerimaDashboardPages";
import { PenerimaTindakLanjutPages } from "./pages/Penerima/PenerimaTindakLanjutPages";
import FileViewerHost from "./componen/FileViewerHost";
import BackupRestoreDBPages from "./pages/Admin/BackupRestoreDBPages";
const guard = (path, element) => (
  <PrivateRoute allowedRoles={ROUTE_ACCESS[path]}>
    {element}
  </PrivateRoute>
);

function App() {
  return (
    <BrowserRouter>
      <FileViewerHost />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/informasi-dasar-hukum" element={<InformasiDasarHukum />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/register-masyarakat" element={<RegisterAkunMasyarakat />} />

        {/* Dashboard per role */}
        <Route path="/admin/dashboard" element={guard("/admin/dashboard", <DashboardPages />)} />
        <Route path="/agr/dashboard" element={guard("/agr/dashboard", <AgrDashboardPages />)} />
        <Route path="/tfl/dashboard" element={guard("/tfl/dashboard", <TflDashboardPages />)} />
        <Route path="/fasilitator/dashboard" element={guard("/fasilitator/dashboard", <FasilitatorDashboardPages />)} />
        <Route path="/supplier/dashboard" element={guard("/supplier/dashboard", <SupplierDashboardPages />)} />
        <Route path="/ppk/dashboard" element={guard("/ppk/dashboard", <PpkDashboardPages />)} />
        <Route path="/kabid/dashboard" element={guard("/kabid/dashboard", <KabidDashboardPages />)} />
        <Route path="/kadis/dashboard" element={guard("/kadis/dashboard", <KadisDashboardPages />)} />
        <Route path="/bupati/dashboard" element={guard("/bupati/dashboard", <BupatiDashboardPages />)} />
        <Route path="/kepaladinas/dashboard" element={guard("/kepaladinas/dashboard", <KepalaDinasDashboardPages />)} />
        <Route path="/penerima/dashboard" element={guard("/penerima/dashboard", <PenerimaDashboardPages />)} />
        <Route path="/penerima/tindak-lanjut" element={guard("/penerima/tindak-lanjut", <PenerimaTindakLanjutPages />)} />
        <Route path="/koordinator-tfl/dashboard" element={guard("/koordinator-tfl/dashboard", <KoordTflDashboardPages />)} />
        <Route path="/koordinator-tfl/monitoring" element={guard("/koordinator-tfl/monitoring", <KoordTflMonitoringPages />)} />

        {/* Route terlindungi */}
        <Route path="/register" element={guard("/register", <Register />)} />
        <Route path="/registerdata" element={guard("/registerdata", <RegisterDataUsulan />)} />
        <Route path="/rekapdatabantuanrumah" element={guard("/rekapdatabantuanrumah", <RegisterUsulanPages />)} />
        <Route path="/recap" element={guard("/recap", <DataRecapPages />)} />
        <Route path="/recapVerifikasi" element={guard("/recapVerifikasi", <RekapVerifikasiPages />)} />
        <Route path="/questionnaire" element={guard("/questionnaire", <QuestionnaireForm />)} />
        <Route path="/questionnaire/:id" element={guard("/questionnaire/:id", <QuestionnaireFormPages />)} />
        <Route path="/upload" element={guard("/upload", <UploadFotoPages />)} />
        <Route path="/uploadpdf" element={guard("/uploadpdf", <UploadPdfPages />)} />
        <Route path="/userlist" element={guard("/userlist", <UserListPages />)} />
        <Route path="/maps" element={guard("/maps", <MapsPages />)} />
        <Route path="/Verifikasi" element={guard("/Verifikasi", <VerifikasiPages />)} />
        <Route path="/backlog" element={guard("/backlog", <DataBacklogPages />)} />
        <Route path="/data-bantuan" element={guard("/data-bantuan", <DataBantuanPages />)} />
        <Route path="/data-bantuan/:id" element={guard("/data-bantuan", <DetailBantuanPages />)} />
        <Route path="/data-bantuan/tambah" element={guard("/data-bantuan/tambah", <TambahDataBantuanPages />)} />
        <Route path="/data-sk" element={guard("/data-sk", <DataSkPenetapanPages />)} />
        <Route path="/proses-bantuan" element={guard("/proses-bantuan", <ProsesBantuanPages />)} />
        <Route path="/proses-bantuan/:id" element={guard("/proses-bantuan", <ProsesBantuanDetailPages />)} />
        <Route path="/monitoring-bantuan" element={guard("/monitoring-bantuan", <MonitoringBantuanPages />)} />
        <Route path="/monitoring-bantuan/:id" element={guard("/monitoring-bantuan", <DetailBantuanPages />)} />
        <Route path="/executive/verifikasi/:id" element={guard("/monitoring-bantuan", <ExecutiveVerifikasiDetail />)} />
        <Route path="/executive/questionnaire/:id" element={guard("/monitoring-bantuan", <ExecutiveQuestionnaireDetail />)} />
        <Route path="/executive/nota/:id" element={guard("/monitoring-bantuan", <ExecutiveNotaDetail />)} />
        <Route path="/presentase-bantuan" element={guard("/presentase-bantuan", <PresentaseBantuanPages />)} />
        <Route path="/rekap-bantuan" element={guard("/rekap-bantuan", <RekapBantuanPages />)} />
        <Route path="/keluhan" element={guard("/keluhan", <KeluhanPages />)} />
        <Route path="/data-supplier" element={guard("/data-supplier", <DataSupplierPages />)} />
        <Route path="/data-pembelian-supplier" element={guard("/data-pembelian-supplier", <DataPembelianSupplierPages />)} />
        <Route path="/input-pembelian" element={guard("/input-pembelian", <InputPembelianPages />)} />
        <Route path="/supplier/bukti-transfer" element={guard("/supplier/bukti-transfer", <SupplierBuktiTransferPages />)} />
        <Route path="/supplier/pengiriman/:id" element={guard("/supplier/pengiriman/:id", <SupplierPengirimanPages />)} />
        <Route path="/supplier/penagihan" element={guard("/supplier/penagihan", <MonitoringPenagihanSupplierPages />)} />
        <Route path="/laporan-rab-supplier" element={guard("/laporan-rab-supplier", <SupplierRabLaporanPages />)} />
        <Route path="/rekap-transaksi-bantuan" element={guard("/rekap-transaksi-bantuan", <RekapTransaksiBantuanPages />)} />
        <Route path="/data-upah-tukang" element={guard("/data-upah-tukang", <DataUpahTukangPages />)} />
        <Route path="/nota-pengiriman" element={guard("/nota-pengiriman", <NotaPengirimanPages />)} />
        <Route path="/admin/backup-restore" element={guard("/admin/backup-restore", <BackupRestoreDBPages />)} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
